module.exports = __webpack_public_path__ + "static/media/BikeSharing-retro6.5aa41f75.pdf";